import { DI } from '@microsoft/fast-foundation';
/**
 * The default configuration for the KVStorage service.
 * @alpha
 */
export const defaultKVStorageConfig = {
    account: 'genesis',
    namespace: 'default',
    authKey: 'kv-default',
    authEmail: 'kv@genesis.global',
};
/**
 * KVStorageConfig DI key.
 *
 * @internal
 */
export const KVStorageConfig = DI.createInterface();
